import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Find the container element
const container = document.getElementById('apc-hero-slider-root');

// Only render if container exists
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}